import React, {useRef} from 'react';
import './ModalWindow.css';
import GreekBorder from "../../GreekBoarder/GreekBorder";
import Quote from "../../Quote/Quote";
import {useCloseOnEnterSpace} from "../../../hooks/input/useCloseOnEnterSpace";
import {useBlurCoveredTextEntry} from "../../../hooks/input/useBlurCoveredTextEntry";

/**
 * overlayClassName / overlayContent — для модалок, которым нужно что-то поверх
 * затемнения рядом с окном (портрет говорящего персонажа в обучении):
 * содержимое кладется в оверлей ПЕРЕД окном.
 * borderColor — постоянный цвет верхней и нижней рамок (иначе — по партии).
 * quotes — набор цитат для showQuote (иначе — все цитаты)
 */
const ModalWindow = ({
  handleClose,
  className,
  showQuote,
  quotes,
  children,
  overlayClassName,
  overlayContent,
  borderColor,
}) => {
  const overlayRef = useRef(null);
  useCloseOnEnterSpace(handleClose);
  // Поле, накрытое модалкой (чат матча в футере), отдает клавиатуру ей:
  // иначе Enter и пробел уходили бы в спрятанный черновик, а не закрывали окно
  useBlurCoveredTextEntry(overlayRef);

  return (
    <div className={`modal-window_overlay ${overlayClassName || ''}`} onClick={handleClose} ref={overlayRef}>
      {overlayContent}
      <div
        className={`modal-window standard-background ${className}`}
        onClick={e => e.stopPropagation()}
      >
        <GreekBorder
          className={'modal-window_greek-boarder-top'}
          noBorder={true}
          color={borderColor}
        />
        {children}
        <GreekBorder
          className={'modal-window_greek-boarder-bottom'}
          noBorder={true}
          color={borderColor}
        />

        {showQuote && (
          <Quote quotes={quotes}/>
        )}
      </div>
    </div>
  );
};

export default ModalWindow;
